import { getRatingColor } from '../../../utils/helpers';
import TextField from '../TextField/TextField';
import './ratingBadge.css';

interface RatingBadgeProps {
    score?: number;
}

export default function RatingBadge({ score }: RatingBadgeProps) {
    return (
        <div
            style={{
                backgroundColor: getRatingColor(score),
                padding: '5px 2px',
                borderRadius: '6px',
                color: '#FFF',
                width: '30px',
                textAlign: 'center',
            }}
        >
            <TextField size="s" color="white" weight="bold">
                {score || 'N/A'}
            </TextField>
        </div>
    );
}
